import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useEffect, useRef } from "react";
import { AppBar, Container, useMediaQuery, Grid, Box, TAGLink, TAGSvgIcon, TAGButton } from "../../../..";
import { useTheme } from "@mui/material/styles";

var MottoHeaderV2 = function MottoHeaderV2(_ref) {
  var contentfulData = _ref.contentfulData,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "dark" : _ref$type;
  var navigationItems = contentfulData.header.navigationLinks;
  var logoUrl = contentfulData.logo.file.url;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMenuOpen = _useState2[0],
      setIsMenuOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      headerTransition = _useState4[0],
      setHeaderTransition = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isMenuScrolled = _useState6[0],
      setIsMenuScrolled = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      mobileMenuFixed = _useState8[0],
      setMobileMenuFixed = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      mobileHeaderShowHideOnScroll = _useState10[0],
      setMobileHeaderShowHideOnScroll = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showFixedScheduleAppointment = _useState12[0],
      setShowFixedScheduleAppointment = _useState12[1];

  var isMobileWidth = useMediaQuery("(max-width: 1023px)");
  var header = useRef(null);
  var headerMenu = useRef(null);
  var scheduleButton = useRef(null);
  var scheduleButtonFixed = useRef(null);
  var theme = useTheme();
  var prevScroll = 0;
  var headerHeight = 90;

  var arrowColorGenerator = function arrowColorGenerator() {
    var menuItemsColors = ["#22a3a6", "#e17090", "#fcd192"];
    var colorIndex = 0;
    return function () {
      var currentColor = menuItemsColors[colorIndex];
      colorIndex >= menuItemsColors.length - 1 ? colorIndex = 0 : colorIndex++;
      return currentColor;
    };
  };

  var arrowColor = arrowColorGenerator();

  var handleOpenNavMenu = function handleOpenNavMenu(event) {
    event.preventDefault();
    setIsMenuOpen(function (prevValue) {
      return !prevValue;
    });
    setMobileHeaderShowHideOnScroll(false);

    if (window.scrollY > headerHeight) {
      setShowFixedScheduleAppointment(false);
    }
  };

  var offset = function offset(el) {
    var top = el.getBoundingClientRect(),
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return top.top + scrollTop;
  };

  var showHideMobileHeader = function showHideMobileHeader() {
    if (isMobileWidth || isMenuOpen) return;

    if (window.scrollY > headerHeight) {
      if (prevScroll > window.scrollY) {
        setMobileHeaderShowHideOnScroll(false);

        if (!showFixedScheduleAppointment) {
          setShowFixedScheduleAppointment(true);
        }
      } else if (prevScroll < window.scrollY) {
        setMobileHeaderShowHideOnScroll(true);
      }
    } else {
      setShowFixedScheduleAppointment(false);
    }

    prevScroll = window.scrollY;
  };

  var onScrollFunc = function onScrollFunc() {
    showHideMobileHeader();
    if (scheduleButton.current == null) return;
    var scheduleApointmentOffsetTop = offset(scheduleButton.current);

    if (window.scrollY >= scheduleApointmentOffsetTop + scheduleButton.current.offsetHeight) {
      setIsMenuScrolled(true);
    } else {
      setIsMenuScrolled(false);
    }

    if (window.scrollY >= scheduleApointmentOffsetTop + headerHeight && !mobileMenuFixed) {
      setMobileMenuFixed(true);
    } else if (window.scrollY > scheduleApointmentOffsetTop + headerHeight && mobileMenuFixed) {
      setMobileMenuFixed(false);
    }

    if (window.scrollY > headerHeight) {
      setHeaderTransition(true);
    } else {
      setHeaderTransition(false);
    }
  };

  var getMenuLogUrl = function getMenuLogUrl() {
    var objWithImg = navigationItems.find(function (n) {
      return !!n.image;
    });

    if (objWithImg !== null && objWithImg !== void 0 && objWithImg.image) {
      return objWithImg.image.file.url;
    }
  };

  useEffect(function () {
    window.addEventListener("scroll", onScrollFunc);
    return function () {
      window.removeEventListener("scroll", onScrollFunc);
    };
  }, []);
  useEffect(function () {
    setIsMenuOpen(false);
    setIsMenuScrolled(false);
    setMobileMenuFixed(false);
  }, [isMobileWidth]);
  return React.createElement(React.Fragment, null, React.createElement(AppBar, {
    position: !isMobileWidth || isMobileWidth && !isMenuOpen && window.scrollY > headerHeight || isMenuOpen ? "sticky" : "relative",
    sx: {
      backgroundColor: type === "dark" ? theme.palette.backgrounds.darkBlue : type === "white" ? "white" : "transparent",
      top: !isMobileWidth || isMobileWidth && !mobileHeaderShowHideOnScroll || isMenuOpen ? 0 : showFixedScheduleAppointment ? "-85px" : "-100%",
      transition: headerTransition ? "all .3s" : ""
    },
    ref: header
  }, React.createElement(Container, {
    sx: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: isMobileWidth && showFixedScheduleAppointment && showFixedScheduleAppointment && !isMenuOpen ? 130 : headerHeight
    }
  }, React.createElement(Grid, {
    container: true,
    alignItems: "center",
    wrap: "nowrap",
    sx: {
      marginTop: "20px"
    }
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGLink, {
    href: "/"
  }, React.createElement("img", {
    style: {
      filter: type === "dark" || type === "transparent" ? "brightness(0) invert(1)" : ""
    },
    src: logoUrl,
    height: 28,
    width: 102
  }))), React.createElement(Grid, {
    item: true,
    container: true,
    alignItems: "center",
    spacing: 2,
    justifyContent: "flex-end"
  }, React.createElement(Grid, {
    item: true
  }, !isMobileWidth && React.createElement(TAGButton, {
    buttonVariant: "Primary Accent01",
    href: "/book-now",
    sx: {
      textTransform: "none",
      background: theme.palette.secondary.dark,
      transition: ".3s ease",
      borderRadius: "25px",
      fontSize: "14px",
      letterSpacing: "0.01em",
      padding: "13px 20px",
      backgroundColor: type === "dark" || type === "transparent" ? "white" : "backgrounds.darkBlue",
      color: type === "dark" || type === "transparent" ? "black" : "text.light",
      "&:hover": {
        backgroundColor: type === "dark" ? "neutrals.primary" : "neutrals.secondary",
        color: type === "dark" ? "black" : "text.light"
      }
    }
  }, "BOOK NOW")), React.createElement(Grid, {
    item: true,
    sx: {
      marginLeft: "30px"
    }
  }, React.createElement(TAGLink, {
    onClick: handleOpenNavMenu,
    sx: {
      color: "white",
      div: {
        width: "35px",
        height: "3px",
        backgroundColor: type === "dark" || type === "transparent" ? "white" : "black",
        margin: "6px 0"
      }
    }
  }, React.createElement("div", null), React.createElement("div", null))))), isMobileWidth && !isMenuOpen && showFixedScheduleAppointment && React.createElement(Box, {
    ref: scheduleButtonFixed,
    sx: {
      position: "absolute",
      bottom: "-35px"
    }
  }, navigationItems.map(function (navigationItem) {
    return navigationItem.buttonUrl ? React.createElement(TAGButton, {
      buttonVariant: "Primary Accent01",
      href: navigationItem.buttonUrl,
      sx: {
        textTransform: "capitalize",
        width: "100%",
        background: theme.palette.secondary.dark,
        color: "text.light",
        transition: ".3s ease",
        height: "70px",
        borderRadius: "35px",
        fontSize: "25px",
        textAlign: "center",
        letterSpacing: "0.01em",
        "&:hover": {
          backgroundColor: "secondary.dark",
          color: "text.light"
        }
      }
    }, navigationItem.buttonText) : "";
  }))), React.createElement(Box, {
    ref: headerMenu,
    sx: {
      position: "fixed",
      // top: '100%',
      top: "90px",
      right: isMenuOpen ? "0px" : "-100%",
      backgroundColor: type === "dark" ? theme.palette.backgrounds.darkBlue : "white",
      zIndex: 99999999999999,
      boxSizing: "border-box",
      width: {
        xs: "100%",
        md: "50%"
      },
      p: {
        xs: "60px 24px 50px 24px",
        md: "40px 50px 100px 100px"
      },
      minHeight: {
        xs: "calc(100vh - 90px)",
        md: "calc(100vh - 90px)"
      },
      maxHeight: "100%",
      overflow: "auto",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      transition: "all .3s ease"
    }
  }, React.createElement(Grid, {
    sx: {
      maxWidth: {
        xs: "100%",
        md: "260px"
      },
      width: "100%"
    }
  }, navigationItems.map(function (navigationItem) {
    return !navigationItem.buttonUrl ? React.createElement(Box, {
      sx: {
        mb: "24px",
        "&:nth-of-type(3n+1)": {
          color: "secondary.dark"
        },
        "&:nth-of-type(3n+2)": {
          color: "accent02.mainDark"
        },
        "&:nth-of-type(3n+3)": {
          color: "accent01.main"
        }
      }
    }, React.createElement(TAGLink, {
      variant: "h2",
      href: navigationItem.path,
      sx: {
        textAlign: {
          xs: "center",
          md: "left"
        },
        ".linkArr": {
          opacity: 0,
          transition: "all .3s ease",
          display: {
            xs: "none",
            md: "inline"
          },
          ml: "10px"
        },
        "&:hover .linkArr": {
          opacity: 1
        }
      }
    }, React.createElement(Box, {
      component: "div",
      sx: {
        display: "inline"
      }
    }, navigationItem.description), React.createElement("span", {
      className: "linkArr"
    }, React.createElement(TAGSvgIcon, {
      icon: "MottoArrowRight",
      size: 25,
      color: "red",
      fill: arrowColor()
    })))) : "";
  })), React.createElement(Grid, {
    sx: {
      display: "flex",
      justifyContent: isMobileWidth ? "center" : "space-between",
      flexDirection: isMobileWidth ? "column" : "",
      alignItems: "center"
    }
  }, React.createElement(Box, {
    ref: scheduleButton,
    sx: {
      marginBottom: isMobileWidth ? "40px" : ""
    }
  }, navigationItems.map(function (navigationItem) {
    return navigationItem.buttonUrl ? React.createElement(TAGButton, {
      buttonVariant: "Primary Accent01",
      href: navigationItem.buttonUrl,
      sx: {
        textTransform: "capitalize",
        width: {
          xs: "100%",
          md: "325px"
        },
        background: theme.palette.secondary.dark,
        color: "text.light",
        transition: ".3s ease",
        height: "70px",
        borderRadius: "35px",
        fontSize: "25px",
        lineHeight: "120%",
        letterSpacing: "0.01em",
        textAlign: "center",
        fontWeight: "800",
        "&:hover": {
          backgroundColor: "secondary.extraDark",
          color: "text.light"
        }
      }
    }, navigationItem.buttonText) : "";
  })), !isMenuScrolled && React.createElement("img", {
    style: {
      filter: type === "dark" || type === "transparent" ? "brightness(0) invert(1)" : ""
    },
    src: getMenuLogUrl(),
    width: "40px",
    height: "42px"
  })))));
};

export default MottoHeaderV2;